import {readChannelLineup} from 'src/shared/channelLineup/actions';
import {address} from 'src/pages/localChannelLineup/store/selectors/address';

export const loadChannels = () =>
  (dispatch, getState) =>
    dispatch(readChannelLineup({address: address(getState())}));
